module.exports = __webpack_public_path__ + "static/media/Chatbot_Notification.66b16d04.mp3";